import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import AppErrorBoundary from "@/AppErrorBoundary";
import PageViewTracker from "@/components/PageViewTracker";
import Landing from "./pages/Landing";

const AdminPage = lazy(() => import("./pages/AdminPage"));
const LegalPrivacidad = lazy(() =>
  import("./pages/LegalPages").then((m) => ({ default: m.Privacidad }))
);
const LegalDatenschutz = lazy(() =>
  import("./pages/LegalPages").then((m) => ({ default: m.Privacidad }))
);
const LegalImpressum = lazy(() =>
  import("./pages/LegalPages").then((m) => ({ default: m.Impressum }))
);

function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F1F5F9]">
      <span className="font-mono text-xs uppercase tracking-widest text-[#94A3B8]">Loading…</span>
    </div>
  );
}

function App() {
  return (
    <AppErrorBoundary>
      <LanguageProvider>
        <div className="App grain" data-testid="app-root">
          <BrowserRouter>
            <PageViewTracker />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route
                path="/admin"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <AdminPage />
                  </Suspense>
                }
              />
              <Route
                path="/privacidad"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <LegalPrivacidad />
                  </Suspense>
                }
              />
              <Route
                path="/datenschutz"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <LegalDatenschutz />
                  </Suspense>
                }
              />
              <Route
                path="/impressum"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <LegalImpressum />
                  </Suspense>
                }
              />
            </Routes>
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </AppErrorBoundary>
  );
}

export default App;
